import LatticePairingModal from './LatticePairingModal'

export default LatticePairingModal
